import React, { useEffect } from 'react';
import { Grid, Button } from '@material-ui/core';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import ReactMarkdown from 'components/common/ReactMarkDown';
import useStyles from '../style';
import Text from '../../../common/Text';

const SurveySuccessScreen = props => {
  const { childName, surveyStatusMessage, t, successIcon = true } = props;
  const classes = useStyles();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 100);
  }, []);

  const isMFS = parseInt(process.env.REACT_APP_SCHOOL_ID) === 1;
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

  return (
    <Grid direction="column" className="w3-center s7t-pss-success-screen">
      <Grid className="w3-margin-top">
        {successIcon && (
          <CheckCircleRoundedIcon
            style={{ fontSize: 80 }}
            className={classes.checkCircleIcon}
          />
        )}
      </Grid>
      {childName ? (
        <>
          <Grid className={classes.marginBottom10}>
            <Text className="s7t-pss-success-txt-1">
              {t('common.surveyCompletedFor', { childName })}
            </Text>
            {isMFS ? (
              <>
                <Text className="s7t-pss-success-txt-0">
                  <br />
                  We would like to hear your thoughts on another one-minute
                  short survey.
                  <br />
                  (you can skip this survey if you have completed it earlier,
                  one response per family is sufficient)
                </Text>
                <br />
                <Text className="s7t-pss-success-txt-1-5">
                  我们诚邀您抽出一分钟的时间填写另一份简短问卷，分享您的宝贵意见。（若您已完成此问卷，无需重复提交；每个家庭提交一次即可。）
                </Text>
                <br />
                <Button
                  className={classes.submitOrNextButton}
                  onClick={() =>
                    window.open(
                      isProduction
                        ? 'https://forms.gle/neBTDxpsv25Z9DJaA'
                        : 'https://www.ntucfirstcampus.com',
                      '_blank'
                    )
                  }
                >
                  <Text className="s7t-pss-link-btn s7t-pss-padding">
                    Start Survey
                    <br />
                    开始问卷
                  </Text>
                </Button>
              </>
            ) : (
              <Text className="s7t-pss-success-txt-2">
                <br />
                <br />
                Thank you for participating in our survey. Your feedback is
                highly appreciated.
                <br />
                谢谢您参与我们的调查。我们非常感激您的反馈。
              </Text>
            )}
          </Grid>
        </>
      ) : (
        <>
          <Grid className={classes.marginBottom10}>
            <ReactMarkdown
              className="s7t-pss-success-txt-2"
              source={surveyStatusMessage}
              escapeHtml={false}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SurveySuccessScreen;
